import {
  INameSpecifiable,
  Entity
} from ".";

export class NameSpecifiedEntity<TId> extends Entity<TId> implements INameSpecifiable {
  constructor(id: TId, public name: string) {
    super(id);
  }

  toString(): string {
    return this.name;
  }
}
